import React, { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/images/Loanonsalary_Logo.png';

const Navbar = () => {
  const location = useLocation();

  // Close navbar on route change
  useEffect(() => {
    const nav = document.getElementById('navbarNav');
    const toggler = document.querySelector('.navbar-toggler');
    if (nav?.classList.contains('show')) {
      toggler?.click();
    }
  }, [location]);

  // Close navbar on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      const nav = document.getElementById('navbarNav');
      const toggler = document.querySelector('.navbar-toggler');
      if (
        nav?.classList.contains('show') &&
        !nav.contains(e.target) &&
        !toggler.contains(e.target)
      ) {
        toggler?.click();
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <header className="dwl-sticky-wrapper">
      <nav className="navbar navbar-expand-lg dwl-navbar-custom">
        <div className="container">
          <NavLink className="navbar-brand dwl-navbar-brand" to="/">
            <img src={logo} alt="Loanonsalary Logo" />
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarNav"
          >
            <ul className="navbar-nav dwl-nav-list">
  <li className="nav-item dwl-nav-item">
    <NavLink to="/" className="dwl-nav-link" end>
      Home
    </NavLink>
  </li>
  <li className="nav-item dwl-nav-item">
    <NavLink to="/about-us" className="dwl-nav-link">
      About Us
    </NavLink>
  </li>
  <li className="nav-item dwl-nav-item">
    <NavLink to="/contact-us" className="dwl-nav-link">
      Contact Us
    </NavLink>
  </li>
  {/* <li className="nav-item dwl-nav-item">
    <NavLink to="/blogs" className="dwl-nav-link">
      Blog
    </NavLink>
  </li> */}
  <li className="nav-item dwl-nav-item">
    <NavLink to="/repay-loan" className="dwl-nav-link">
      Repay Loan Singh Fin.
    </NavLink>
  </li>
  <li className="nav-item dwl-nav-item">
    <NavLink to="/repay-marathon" className="dwl-nav-link">
      Repay Marathon
    </NavLink>
  </li>
  <li className="nav-item dwl-nav-item">
    <NavLink to="/apply-now" className="dwl-apply-btn">
      Apply Now
    </NavLink>
  </li>
</ul>

          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
